import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'flash-messages-angular';
import { AdminService } from 'src/app/services/admin.service';

@Component({
  selector: 'app-invite',
  templateUrl: './invite.component.html',
  styleUrls: ['./invite.component.css']
})
export class InviteComponent implements OnInit {

  // Model to hold info
  model = {
    email: '',
    type: '',
    agency: '',
  }

  // Agencies
  agencies: any = [];

  constructor(private router: Router, private adminService: AdminService, private flashMessage: FlashMessagesService) { }

  // Load  active agencies
  ngOnInit(): void {
    this.adminService.getActiveAgencies().toPromise().then((data: any) => {
      this.agencies = data;
    })
  }

  // Invite admin
  onSubmit() {
    this.adminService.inviteAdmin(this.model).toPromise().then((data: any) => {

      // Success
      if (data.success) {

        // Display success
        this.flashMessage.show("Successfully invited.", {
          cssClass: 'alert-success',
          timeout: 3000
        });

        this.router.navigate(['/admin/home']);
      }

      // Error
      else {

        // Display error
        this.flashMessage.show(data.message, {
          cssClass: 'alert-danger',
          timeout: 3000
        });
      }
    })
  }
}
